<template>
  <div class="mall">
    <div class="nav-user">
      <div class="user-info">
        <van-image
          round
          class="user-info-avatar"
          :src="userInfo.headimgurl"
          fit="cover"
        ></van-image>
        <div class="user-info-text">
          <div class="user-info-name">{{ userInfo.nickname }}</div>
          <div class="user-info-sign">
            等级：{{ userInfo.level_msg }}
            <span class="user-info-sign-rule" @click="scoreRuleClick"
              >积分兑奖规则</span
            >
          </div>
        </div>
        <div class="user-info-integral">
          <div class="user-info-score">积分：{{ userInfo.score }}</div>
          <div class="user-info-recode" @click="recodeClick">兑换记录</div>
        </div>
      </div>
      <div class="user-score"></div>
    </div>
    <van-list
      class="item-list"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      offset="30"
    >
      <mall-item
        class="gift-item"
        v-for="item in gifts"
        :key="item.id"
        :data="item"
        @click.native="itemClick(item.id)"
      />
    </van-list>
  </div>
</template>
<script>
import MallItem from "./child/MallItem";
import { getGifts } from "network/mall";

export default {
  name: "Mall",
  components: {
    MallItem,
  },
  data() {
    return {
      gifts: [],
      userInfo: {},
      loading: false,
      finished: false,
      page: 0,
    };
  },
  computed: {},
  created() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
  },
  mounted() {},
  methods: {
    onClickLeft() {
      this.$router.back();
    },
    itemClick(id) {
      this.$router.push({
        path: "/malldetail",
        query: {
          id,
        },
      });
    },
    //点击兑换记录
    recodeClick() {
      this.$router.push({ path: "/profileoder" });
    },
    //积分规则
    scoreRuleClick() {
      this.$router.push({ path: "/integralrules" });
    },
    //加载更多
    onLoad() {
      this.getGifts();
    },
    /**
     * 请求
     */
    //积分商城列表
    getGifts() {
      getGifts(++this.page).then((res) => {
        this.gifts = this.gifts.concat(res.data);
        this.loading = false;

        if (res.data.length < 20) {
          this.finished = true;
        }
      });
    },
  },
};
</script>
<style scoped>
.mall {
  padding: 20px 15px 15px 15px;
  background: #fff;
}
.user-info {
  display: flex;
}
.user-info-avatar {
  width: 50px;
  height: 50px;
  border-radius: 30px;
  border: 1px solid #707070;
}
.user-info-text {
  flex: 1;
  margin-left: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.user-info-name {
  font-size: 14px;
  font-weight: 700;
}
.user-info-sign {
  font-size: 13px;
}
.user-info-sign-rule {
  margin-left: 5px;
  font-size: 12px;
  text-decoration: underline;
  color: #707070;
}
.user-info-integral {
  /* flex: 1; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
}
.user-info-score {
  font-size: 14px;
  font-weight: 600;
}
.user-info-recode {
  font-size: 13px;
  font-weight: 600;
  text-decoration: underline;
}

.item-list {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
::v-deep .van-list__finished-text {
  width: 100%;
}
.gift-item {
  width: 166px;
}
</style>